// Rahmen-Website: liegt über allen Programmen (Anmeldung, Seitenleiste mit Programmwechsel, Befehlspalette) und lädt
// das jeweilige Programm als eigene Website im Inhaltsbereich.
import "@imho/ui/stil/einbinden";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { RueckmeldungProvider } from "@imho/ui/bausteine/rueckmeldung";
import { rahmenMarkieren } from "@imho/ui/kern/rahmen";
import { SitzungProvider } from "@imho/ui/kern/sitzung";
import { abfragenErstellen, themaVerfolgen } from "@imho/ui/navigation/programm";
import Anmelden from "@imho/ui/seiten/Anmelden";
import { Absturz } from "@imho/ui/seiten/Fehlerseiten";
import { Rahmen } from "./Rahmen";

rahmenMarkieren();
themaVerfolgen();

const router = createBrowserRouter([
  { path: "/anmelden", element: <Suspense fallback={null}><Anmelden /></Suspense>, errorElement: <Absturz /> },
  { path: "*", element: <Rahmen />, errorElement: <Absturz /> },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={abfragenErstellen()}>
      <SitzungProvider>
        <RueckmeldungProvider>
          <RouterProvider router={router} />
        </RueckmeldungProvider>
      </SitzungProvider>
    </QueryClientProvider>
  </StrictMode>,
);
